//////////////////////////////////////////////////

const item_status   = require('./item/status').default;
const item_owner    = require('./item/owner').default;
const item_download = require('./item/download').default;
const item_qrcode   = require('./item/qrcode').default;
const item_email    = require('./item/email').default;
const item_ab       = require('./item/action_buttons').default;

module.exports = {
    'item/status'   : item_status,
    'item/owner'    : item_owner,
    'item/download' : item_download,
    'item/qrcode'   : item_qrcode,
    'item/email'    : item_email,
    'item/ab'       : item_ab,
}
